module.exports = __webpack_public_path__ + "assets/bb821c4cbd6de2b5ecce90650c02c545.png";